import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b2801ede")

_pushScopeId("data-v-b2801ede")
const _hoisted_1 = { class: "tab-page spread" }
const _hoisted_2 = { class: "fill p-r" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tab = _resolveComponent("Tab")
  const _component_TransitionProvider = _resolveComponent("TransitionProvider")
  const _component_RouterView = _resolveComponent("RouterView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Tab, { class: "tab" }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_RouterView, null, {
        default: _withId(({ Component, route }) => [
          _createVNode(_component_TransitionProvider, {
            name: route.meta.transition
          }, {
            default: _withId(() => [
              (_openBlock(), _createBlock(_KeepAlive, { include: ['Home'] }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 2
          }, 1032, ["name"])
        ]),
        _: 1
      })
    ])
  ]))
})